import LocalizedStrings from "react-localization";

const en = require("./languages/en.json");
const it = require("./languages/it.json");
const lang = localStorage.getItem('SA_user_lang') || 'En';

class SingletonStrings {
  constructor() {
    this.instance = new LocalizedStrings({
      En: en,
      It: it
    });
    return this.instance;
  }
}

var ex = new SingletonStrings();
ex.setLanguage(lang);

export default ex;
